import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmModal /*, removeModal*/, isMobileScreen } from '@apply/ui';
import { Drawer } from 'devextreme-react';
import { useAuthentication } from './LoginPage';
//import { useIdleTimer } from 'react-idle-timer';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { DrawerNavigationList } from './DrawerNavigationList';
import './drawerNavigation.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOut } from '@fortawesome/free-solid-svg-icons';

const reactPlugin = new ReactPlugin();
const mobileScreen = isMobileScreen();

export const appInsightsApply = import.meta.env.VITE_APPINSIGHTS_CLIENT_APPLY;
const ai = new ApplicationInsights({
    config: {
        instrumentationKey: appInsightsApply,
        enableAutoRouteTracking: true,
        extensions: [reactPlugin],
    },
});
ai.loadAppInsights();

export const Header: React.FC<{ printMode? }> = ({ printMode }) => {
    const { authentication, isAuthenticated, logout } = useAuthentication();
    const navigate = useNavigate();

    const [name, setName] = useState<string>('');
    // const [initials, setInitials] = useState<string>('');
    const [drawerOpened, setDrawerOpened] = useState(false);
    // const [logoutTimeout, setLogoutTimeout] = useState<NodeJS.Timeout>();
    // const [isIdle, setIsIdle] = useState(false);
    // const idleWarningDuration = 1000 * 60 * 2;
    // const sessionDuration = 1000 * 60 * 20;
    // const idleDuration = sessionDuration - idleWarningDuration;

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        } else {
            setName(`${authentication.user.firstName} ${authentication.user.lastName}`);
            // setInitials(
            //     `${authentication.user.firstName.charAt(
            //         0
            //     )}${authentication.user.lastName.charAt(0)}`
            // );
        }
    }, [authentication, isAuthenticated]);

    const onConfirmLogout = () => {
        const stackTrace = Error().stack;
        ai.appInsights.trackTrace({ message: 'onConfirmLogout' }, { stackTrace });
        logout();
        navigate('/login');
    };

    const handleLogout = () => {
        confirmModal({
            title: 'Confirm Logout',
            message: `Warning: Unsaved work may be lost`,
            onConfirm: onConfirmLogout,
            okLabel: 'Yes',
            cancelLabel: 'No',
        });
    };

    const handleDrawerClick = () => {
        setDrawerOpened(!drawerOpened);
    };

    return (
        <>
            <header>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-evenly',
                    }}
                >
                    <div style={{ width: '30%' }}></div>
                    <div style={{ width: '40%', textAlign: 'center' }}>
                        <a
                            href='/'
                            className='logo no-print'
                        >
                            <img
                                src='/assets/img/logo.webp.html'
                                alt='Builder Finance'
                            />
                        </a>
                    </div>
                    <div
                        style={{
                            width: '30%',
                            visibility: isAuthenticated ? 'visible' : 'hidden',
                            paddingTop: '10px',
                            textAlign: 'right',
                        }}
                    >
                        <span className={`show-for-large ${printMode ? 'hidden' : ''}`}>{name}</span>
                        <span
                            className={`${printMode ? 'hidden' : ''}`}
                            style={{
                                cursor: 'pointer',
                                paddingLeft: '20px',
                                paddingRight: '20px',
                            }}
                        >
                            <span
                                className={`${drawerOpened ? 'drawerBtnStyle-open' : 'drawerBtnStyle-closed'} icon`}
                                title='Menu'
                                onClick={handleDrawerClick}
                                style={{ padding: '5px', borderRadius: '3px' }}
                            >
                                <FontAwesomeIcon icon={faBars} />
                            </span>
                        </span>
                        <span
                            className={`${printMode ? 'hidden' : ''}`}
                            title='Logout'
                            onClick={handleLogout}
                            style={{ cursor: 'pointer', paddingRight: '10px' }}
                        >
                            <FontAwesomeIcon icon={faSignOut} />
                        </span>
                    </div>
                </div>
                <div
                    style={{
                        paddingTop: '15px',
                        width: '200px',
                        position: 'absolute',
                        right: '0',
                        zIndex: drawerOpened ? '2000' : '0',
                    }}
                >
                    <Drawer
                        opened={drawerOpened}
                        openedStateMode='overlap'
                        position='right'
                        revealMode='slide'
                        component={DrawerNavigationList}
                        closeOnOutsideClick={true}
                        /* full menu should be 250px height with 200px div width - TBD Future Cards */
                        height='180px'
                    />
                </div>
            </header>
            {!mobileScreen && (
                <div
                    className='page-header'
                    role='banner'
                >
                    <div className='row'>
                        <div className='columns'>
                            <h1>Apply</h1>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
